package team.platforma.multiplatform_material_extension.tab_row

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.pager.PagerState
import androidx.compose.material3.ScrollableTabRow
import androidx.compose.material3.Tab
import androidx.compose.material3.TabPosition
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.zIndex
import team.platforma.multiplatform_material_extension.tab_row.style.AdaptiveTabRowStyle

@Composable
fun <T> AdaptiveTabRow(
    pagerState: PagerState,
    tabList: List<T>,
    modifier: Modifier = Modifier,
    edgePadding: Dp = AdaptiveTabRowStyle.tabRow().edgePadding,
    divider: @Composable () -> Unit = AdaptiveTabRowStyle.tabRow().divider,
    indicator: @Composable (tabPositions: List<TabPosition>, selectedTabIndex: Int, list: List<Any>) -> Unit = { tabPositions, selectedTabIndex, list ->
        AdaptiveTabRowStyle.tab().indicator(tabPositions, selectedTabIndex, list)
    },
    onTabClick: (Int) -> Unit = {},
    tab: @Composable (T) -> Unit
) {

    val tabContentPadding = 16.dp
//    var listTabSize by remember { mutableStateOf(List(tabList.size) { 0.dp }.toMutableList()) }
    val listTabSize by remember(tabList) {
        derivedStateOf {
            MutableList(tabList.size) { 0.dp }
        }
    }

    var contentWidth by remember { mutableStateOf(0.dp) }
    var spaceWight by remember { mutableStateOf(0.dp) }

    val customPadding = AdaptiveTabRowStyle.tabRow().customTabPadding

    LaunchedEffect(listTabSize, contentWidth) {
        val result = listTabSize.fold(0.dp) { acc, dp -> acc + dp }

        if (result < contentWidth) {
            val tabLayoutPadding = edgePadding * 2
            val tabPadding = tabContentPadding * 2
            val mCustomPadding = customPadding * 2
            val resultCustomPadding = mCustomPadding * listTabSize.size
            val tabsContentPadding = tabPadding * listTabSize.size
            val allPaddings = tabLayoutPadding + tabsContentPadding + resultCustomPadding
            val adaptive = (contentWidth - allPaddings) / listTabSize.size
            spaceWight = adaptive
        }
    }

    val density = LocalDensity.current

    Box(
        modifier = Modifier.fillMaxWidth()
            .onGloballyPositioned { layoutCoordinates ->
                val width = layoutCoordinates.size.width
                contentWidth = with(density) { width.toDp() }
            }
    )

    ScrollableTabRow(
        selectedTabIndex = pagerState.currentPage,
        modifier = modifier,
        edgePadding = edgePadding,
        divider = divider,
        containerColor = AdaptiveTabRowStyle.tabRow().containerColor,
        contentColor = AdaptiveTabRowStyle.tabRow().contentColor,
        indicator = { tabPositions ->

            val selectedTabIndex = pagerState.currentPage
            @Suppress("UNCHECKED_CAST")
            indicator(tabPositions, selectedTabIndex, tabList as List<Any>)
        }
    ) {
        tabList.forEachIndexed { index, T ->
            Tab(
                text = {
                    Box(
                        modifier = Modifier,
                        contentAlignment = Alignment.Center
                    ) {
                        tab(T)
                        Spacer(
                            modifier = Modifier.width(spaceWight)
                        )
                    }

                },
                modifier = Modifier.zIndex(1f).fillMaxWidth()
                    .onGloballyPositioned { layoutCoordinates ->
                        val width = layoutCoordinates.size.width
                        val tabWidth = with(density) { width.toDp() }
                        listTabSize.toMutableList().apply {
                            this[index] = tabWidth
                        }
                    }
                    .then(
                        if (pagerState.currentPage == index) {
                            AdaptiveTabRowStyle.tab().checkedTabModifier
                        } else {
                            AdaptiveTabRowStyle.tab().defaultTabModifier
                        }
                    ),
                selected = pagerState.currentPage == index,
                selectedContentColor = AdaptiveTabRowStyle.tab().selectedContentColor,
                unselectedContentColor = AdaptiveTabRowStyle.tab().unselectedContentColor,
                onClick = {
                    onTabClick(index)
                }
            )
        }
    }
}